import { useEffect, useState } from "react"
import LicenceSelectPage from "./pages/LicenceSelectPage"
import { getMyShareLinks } from "routes/shared-with-me/controller/get-my-share-links"
import { Bound } from "lib/@components/binding/Bound"
import { pageNames } from "plugins/Paywall/paywall-constants"
import PurchasePage from "./pages/PurchasePage"
import { ShareLinkContactPage } from "plugins/Paywall/pages/ShareLinkContactPage"
import { SubscriptionContactPage } from "plugins/Paywall/pages/SubscriptionContactPage"
import { getAutoOpenShareLink } from "plugins/Paywall/paywall-share-link-access"
import LoadingScreen from "minimals-template/components/LoadingScreen"
import { AdoptClient, AuthorizationUpdated, FlushGraphQLCache } from "event-definitions"
import { IS_LOADING } from "lib/graphql/return-is-loading-on-each-request"
import { withInitialValue } from "lib/graphql/with-initial-value"
import { invalidate } from "lib/graphql/cache"

const pageComponents = {
    licenceSelect: LicenceSelectPage,
    contact: SubscriptionContactPage,
    share: ShareLinkContactPage,
    purchase: PurchasePage,
}

function Paywall() {
    const [page, setPage] = useState(pageNames.licenceSelect)
    const [selectedLicense, setSelectedLicense] = useState()

    AuthorizationUpdated.useEvent(refreshShareLinks)
    const myShareLinks = getMyShareLinks.useResults(withInitialValue(IS_LOADING))
    const links = myShareLinks === IS_LOADING ? [] : myShareLinks?.links ?? []
    const autoOpenShareLink = getAutoOpenShareLink(links)
    useEffect(openShareLink, [autoOpenShareLink?.url])

    const [selectedShareLinkLicense] = links.filter((link) => link.name === selectedLicense)
    const Page = selectedShareLinkLicense ? pageComponents[pageNames.share] : pageComponents[page]

    if (myShareLinks === IS_LOADING) return <LoadingScreen />
    if (autoOpenShareLink) return <LoadingScreen description="Opening shared link" />

    return (
        <Bound links={links}>
            <Page
                setPage={setPage}
                selectedLink={selectedShareLinkLicense}
                selectedLicense={selectedLicense}
                setSelectedLicense={setSelectedLicense}
            />
        </Bound>
    )

    function openShareLink() {
        if (!autoOpenShareLink?.url) return
        FlushGraphQLCache.raise()
        AdoptClient.raise(undefined)
        window.location.href = autoOpenShareLink.url
    }

    function refreshShareLinks() {
        // Which links are viewable depends on the current auth/client context, so
        // re-fetch when authorization changes; otherwise the auto-open/no-licence
        // flow can act on stale share data.
        invalidate("getMyShareLinks")
    }
}

export default Paywall
